module.exports = __webpack_public_path__ + "static/media/category-banner-play.bd7e9db1.svg";